import React, { useEffect, useRef } from 'react';
import WebSolutionsHero from './WebSolutionsHero/WebSolutionsHero';
import AboutWebSolution from './AboutWebSolution/AboutWebSolution';
import PhaseDevelopment from './PhaseDevelopment/PhaseDevelopment';
import PostLaunch from './PostLaunch/PostLaunch';
import WithUs from '../../Landing/WithUs/WithUs';
import Footer from '../../../Components/Footer/Footer';
import WebSolutionPortfolioPart from './WebSolutionPortfolioPart/WebSolutionPortfolioPart';
import WebTypes from './WebTypes/WebTypes';
import SeoHelmet from '../../../Components/SeoHelmet';

const WebSolutionsLanding = () => {
  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className='overflow-hidden'>
      <div ref={scrollRef}></div>
      <SeoHelmet
        title="SunMed | Web Solutions"
        description="SunMed:Build Trust & Credibility – A professional website gives customers confidence in your brand."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <WebSolutionsHero/>
      <AboutWebSolution/>
      <WebSolutionPortfolioPart/>
      <PhaseDevelopment/>
      <WebTypes/>
      <PostLaunch/>
      <WithUs/>
      <Footer/>
    </div>
  );
}

export default WebSolutionsLanding;
